export const HELP_VIDEO_FETCH_ALL = 'HELP_VIDEO_FETCH_ALL';
export const HELP_VIDEO_FETCH_ALL_SUCCESS = 'HELP_VIDEO_FETCH_ALL_SUCCESS';
export const HELP_VIDEO_FETCH_ALL_FAIL = 'HELP_VIDEO_FETCH_ALL_FAIL';
export const HELP_VIDEO_ADD = 'HELP_VIDEO_ADD';
export const HELP_VIDEO_ADD_SUCCESS = 'HELP_VIDEO_ADD_SUCCESS';
export const HELP_VIDEO_ADD_FAIL = 'HELP_VIDEO_ADD_FAIL';
export const HELP_VIDEO_UPDATE = 'HELP_VIDEO_UPDATE';
export const HELP_VIDEO_UPDATE_SUCCESS = 'HELP_VIDEO_UPDATE_SUCCESS';
export const HELP_VIDEO_UPDATE_FAIL = 'HELP_VIDEO_UPDATE_FAIL';
export const HELP_VIDEO_DELETE = 'HELP_VIDEO_DELETE';
export const HELP_VIDEO_DELETE_SUCCESS = 'HELP_VIDEO_DELETE_SUCCESS';
export const HELP_VIDEO_DELETE_FAIL = 'HELP_VIDEO_DELETE_FAIL';
export const HELP_VIDEO_SET_SORT = 'HELP_VIDEO_SET_SORT';
export const HELP_VIDEO_SET_PAGE = 'HELP_VIDEO_SET_PAGE';
export const HELP_VIDEO_SET_PAGE_SIZE = 'HELP_VIDEO_SET_PAGE_SIZE';
export const HELP_VIDEO_SET_VIEW = 'HELP_VIDEO_SET_VIEW';
